(() => {
  if (window.__infiniteScrollLoaded) return;
  window.__infiniteScrollLoaded = true;

  const SELECTOR = '[data-infinite-scroll]';
  const loading = new WeakSet();

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) loadMore(entry.target);
      });
    },
    { rootMargin: '800px 0px' }
  );

  async function loadMore(sentinel) {
    const nextUrl = sentinel.dataset.nextUrl;
    if (!nextUrl || loading.has(sentinel)) return;
    loading.add(sentinel);

    try {
      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', sentinel.dataset.sectionId);

      const response = await fetch(url.toString());
      if (!response.ok) throw new Error('HTTP ' + response.status);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const list = sentinel.parentElement.querySelector('product-list');
      const fragment = document.createDocumentFragment();

      doc.querySelectorAll('product-list > *').forEach((item) => {
        fragment.appendChild(document.importNode(item, true));
      });
      list.appendChild(fragment);

      const newSentinel = doc.querySelector(SELECTOR);
      if (newSentinel) {
        sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
        loading.delete(sentinel);
        io.unobserve(sentinel);
        io.observe(sentinel); // dobara check karega ke sentinel abhi bhi view mein hai ya nahi
      } else {
        io.unobserve(sentinel);
        sentinel.remove();
      }
    } catch (error) {
      console.error('Infinite scroll error:', error);
      loading.delete(sentinel);
    }
  }

  const scan = () => document.querySelectorAll(SELECTOR).forEach((el) => io.observe(el));

  // Filters/sort section ko dobara render karte hain, to naya sentinel yahan se pakra jata hai
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  scan();
})();